// import { setCompanies } from '../reducers/companyReducer';
import { toast } from 'react-toastify';
// import { getCompanies } from '../../services/apiService';

export function loadAllCompanies() {
  return async (dispatch) => {
    try {
      // const companies = await getCompanies();
      // dispatch(setCompanies(companies));
    } catch (e) {
      toast.error('Error loading companies');
    }
  };
}
